import TablePaginationController from './table_pagination_controller';

export default class extends TablePaginationController {
  initialize() {}

  async select(e) {
    const page = e.target.getAttribute('data-table-pagination-page');
    this.__updatePage(page);
  }

  prevPage() {
    const currentPage = parseInt(this.data.get('current-page'));
    this.__updatePage(currentPage -1);
  }

  nextPage() {
    const currentPage = parseInt(this.data.get('current-page'));
    this.__updatePage(currentPage + 1);
  }

  __updatePage(page) {
    window.location.assign(`?page=${page}`)
  }

  __updateCurrentPageState() {
    const currentPage = this.data.get('current-page');
    this.element.querySelectorAll('[data-table-pagination-page]').forEach(element => element.classList.remove('m-table-pagination-page-button__selected'))
    this.element.querySelector(`[data-table-pagination-page="${currentPage}"]:not(.t-hidden)`).classList.add('m-table-pagination-page-button__selected')
  }
}
